import { ProductsApiService } from './service';
import ApiClientFactory from '../../api/client-factory';

const service = new ProductsApiService(ApiClientFactory());

export function ProductsApiServiceFactory(): typeof service {
  return service;
}
